export default __webpack_public_path__ + "static/media/cloud1.ed831e1a.jpg";